<template src='./user-create.html'></template>

<script>
import Vue from 'vue'
import ContextPage from '@/components/misc/context-page/ContextPage'
import { EventBus } from '@/router/bus'

export default {
  components: {
    ContextPage
  },
  data () {
    return {
      user: {
        login: '',
        loginAd: '',
        name: '',
        email: '',
        roleId: 1,
        notifyUser: true
      },
      help: {
        create: Vue.$helpConfig.userCreate
      },
      generateLogin: true,
      roles: [],
      dialog: false,
      formValid: true,
      loading: false,
      usernameRules: [
        v => !!(this.generateLogin || v.trim()) || this.$t('validation.usernameRequired'),
        v => (this.generateLogin || (v && v.length <= 32)) || this.$t('validation.usernameTooLong')
      ],
      nameRules: [
        v => !!(v.trim()) || this.$t('validation.nameRequired')
      ],
      emailRules: [
        v => !!(v.trim()) || this.$t('validation.emailRequired'),
        v => /.+@.+\..+/.test(v) || this.$t('validation.emailRequired')
      ]
    }
  },
  watch: {
    generateLogin (val) {
      if (this.user.name) {
        if (!val) {
          this.getUniqueLogin(this.user.name)
        }
      } else {
        this.user.login = ''
      }
    }
  },
  created () {
    this.retrieveRoles()
  },
  methods: {
    retrieveRoles () {
      this.loading = true
      this.$http.get(Vue.$apiConfig.availableRolesGet).then(
        response => {
          this.logConsole(response)
          this.roles = response.data.payload
          this.loading = false
        },
        error => {
          this.formatErrorResponse(error)
          this.loading = false
        }
      )
    },
    getUniqueLogin (name) {
      this.loading = true
      this.$http.get(Vue.$apiConfig.generateLogin + '?name=' + name).then(
        response => {
          this.logConsole(response)
          this.user.login = response.data.payload
          this.loading = false
        },
        error => {
          this.formatErrorResponse(error)
          this.loading = false
        }
      )
    },
    getUniqueLoginAndAddUser (name) {
      this.loading = true
      this.$http.get(Vue.$apiConfig.generateLogin + '?name=' + name).then(
        response => {
          this.logConsole(response)
          this.user.login = response.data.payload
          this.addUser()
        },
        error => {
          this.formatErrorResponse(error)
          this.loading = false
        }
      )
    },
    validateBeforeSubmit () {
      if (this.generateLogin) {
        this.getUniqueLoginAndAddUser(this.user.name)
      } else {
        this.addUser()
      }
    },
    addUser () {
      this.loading = true
      this.dialog = false
      const addUserURL = Vue.$apiConfig.createUserPost
      var user = this.user
      if (user.loginAd === undefined || user.loginAd === '') {
        user.loginAd = null
      }
      var users = []
      users.push(user)
      this.$http.post(addUserURL, users).then(
        response => {
          if (response.body.payload && response.body.payload[0].error) {
            this.formatSuccessErrorsResponse(response.body.payload[0].error)
            this.loading = false
            return
          } else {
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('userAdministration.createUserSuccessful'),
              errors: []
            })
            this.loading = false
          }
          this.dialog = false
          this.resetUser()
          // console.log(response)
          const login = response.data.payload[0].user.login
          this.$router.push('/administration/user/' + login)
        },
        error => {
          this.formatErrorResponse(error)
          this.loading = false
          this.scrollToForm()
        })
    },
    openDialog () {
      if (!this.$refs.form.validate()) {
        this.scrollToForm()
        return
      }

      if (this.user.roleId === 0) {
        EventBus.$emit('alert', {
          variant: 'error',
          message: this.$t('validation.claimRequired'),
          errors: []
        })
        return
      }
      this.dialog = true
    },
    resetUser () {
      this.user = {
        login: '',
        loginAd: '',
        name: '',
        email: '',
        roleId: 1,
        notifyUser: true
      }
      this.generateLogin = true

      this.$refs.form.resetValidation()
      this.scrollToForm()
    },
    scrollToForm () {
      const FORM = 'form'
      var element = this.$refs[FORM]
      var top = element.offsetTop

      window.scrollTo(0, top)
    }
  }
}
</script>
